import React from 'react';
import { Spinner } from '@billda/design-system';
import { LabourItemGroupDetails } from '../api/labourItemGroupsApi';
import { useLabourGroupsPanelStore } from '../stores/labourGroupsPanelStore';
import { GroupOverviewCard } from './panel/molecules/GroupOverviewCard';
import { GroupLabourItemsCard } from './panel/molecules/GroupLabourItemsCard';
import { GroupActions } from './panel/molecules/GroupActions';

interface GroupDetailsPanelProps {
  group: LabourItemGroupDetails | null;
  loading?: boolean;
  onDelete: (group: LabourItemGroupDetails) => void;
}

const GroupDetailsPanel: React.FC<GroupDetailsPanelProps> = ({
  group,
  loading = false,
  onDelete,
}) => {
  const switchMode = useLabourGroupsPanelStore(state => state.switchMode);
  const setEditedGroupName = useLabourGroupsPanelStore(
    state => state.setEditedGroupName
  );

  const handleEditClick = () => {
    if (group) {
      setEditedGroupName(group.name);
      switchMode('edit');
    }
  };

  return (
    <div className="p-5 sm:p-6">
      {loading ? (
        <div
          className="flex justify-center p-1"
          data-testid="group-details-loading"
        >
          <Spinner />
        </div>
      ) : group ? (
        <div
          className="flex flex-col gap-6"
          data-testid="group-details-content"
        >
          {/* Group Overview Card */}
          <GroupOverviewCard group={group} />

          {/* Labour Items Card */}
          <GroupLabourItemsCard labourItems={group.labourItems || []} />

          {/* Actions Card */}
          <GroupActions
            onEdit={handleEditClick}
            onDelete={() => onDelete(group)}
          />
        </div>
      ) : (
        <p className="type-body-md text-center text-content-secondary">
          No group details available
        </p>
      )}
    </div>
  );
};

export default GroupDetailsPanel;
